exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n#rule-tabs > .tabs-component > .tabs-component-tabs {\n  display: block;\n}\n#rule-tabs > .tabs-component > .tabs-component-tabs > .tabs-component-tab > .tabs-component-tab-a {\n  padding: 0em 2.5em;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-3b28b1fe","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/components/revenue/Rules.vue
// module id = 3129
// module chunks = 0